<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">敏感資料方案</h1>
                        <h2>最高等級的資料安全與隱私保護</h2>
                        <p>不參與 AI 訓練、完整資料控管、不儲存任何資料</p>
                        <div class="btn-group">
                            <button  class="filled-btn" type="button" (click)="scroll(target)">聯繫我們</button>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <iframe width="100%" height="310" src="https://www.youtube.com/embed/3wTToHVpBE0" title="LaTeX Proofreading | LaTeX Grammar Checker by Trinka AI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="data-card list-wrapper-style-2 section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title text-white position-relative">
                    <h2 class="text-white mb-4 text-center">資料隱私保護承諾</h2>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media">
                        <div class="media-left">
                            <svg width="50" height="50" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M41.4301 47.19L30.8101 36.57" stroke="#7A28A0" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M41.3099 36.69L30.6899 47.31" stroke="#7A28A0" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M66 33V51C66 63 63 66 51 66H21C9 66 6 63 6 51V21C6 9 9 6 21 6H25.5C30 6 30.99 7.32 32.7 9.6L37.2 15.6C38.34 17.1 39 18 42 18H51C63 18 66 21 66 33Z" stroke="#7A28A0" stroke-width="3" stroke-miterlimit="10"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>即時刪除處理資料</h3>
                        </div>
                    </div>
                    <p>所有處理過的資料不會被持久儲存，並會在處理完成後立即自動刪除。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media">
                        <div class="media-left">
                            <svg width="50" height="50" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M60 28.8C60 16.8 55.2 12 43.2 12H28.8C16.8 12 12 16.8 12 28.8V43.2C12 55.2 16.8 60 28.8 60" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M49.05 24C47.4 21.9 44.64 21 40.5 21H31.5C24 21 21 24 21 31.5V40.5C21 44.64 21.9 47.4 23.97 49.05" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M24.03 12V6" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M36 12V6" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M48 12V6" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M60 24H66" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M24.03 60V66" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6 24H12" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6 36H12" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6 48H12" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M66 40L40 66" stroke="#7A28A0" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M66 66L40 40" stroke="#7A28A0" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>不參與 AI 訓練</h3>
                        </div>
                    </div>
                    <p>您的機密內容不會用於任何 AI 模型訓練，100% 保留資料所有權與控制權。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-12 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <div class="media">
                        <div class="media-left">
                            <svg width="50" height="50" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M31.47 6.68999L16.5 12.33C13.05 13.62 10.23 17.7 10.23 21.36V43.65C10.23 47.19 12.57 51.84 15.42 53.97L28.32 63.6C32.55 66.78 39.51 66.78 43.74 63.6L56.64 53.97C59.49 51.84 61.83 47.19 61.83 43.65V21.36C61.83 17.67 59.01 13.59 55.56 12.3L40.59 6.68999C38.04 5.75999 33.96 5.75999 31.47 6.68999Z" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M23.993 2.67432L9.19709 8.127C5.78721 9.37415 3 13.3186 3 16.8571V38.4068" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M27.15 35.61L31.98 40.44L44.88 27.54" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="media-body">
                            <h3>資安與法規遵循</h3>
                        </div>
                    </div>
                    <p>Trinka 採用高標準資安機制，確保滿足貴組織的資安政策與法規要求。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true">
                    <source src="/assets/images/video/data-sensitive-video.mp4#t=0.1" type="video/mp4">
                    Your browser does not support the video element. Kindly update it to latest version.
                </video>
            </div>
        </div>
    </div>
</section>

<section class="bg-light section-pd-sm">
    <app-trusted-global-leaders></app-trusted-global-leaders>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row no-margin flex-row-reverse align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="list-wrapper-content-2 pl-40">
                    <h3>資料處理政策</h3>
                    <ul class="bullets-box">
                        <li>您擁有資料的完整所有權</li>
                        <li>資料僅用於提供 Trinka 功能，不會另作他用</li>
                        <li>使用「敏感資料方案」的用戶，其資料會即時刪除，不留任何紀錄</li>
                        <li>為分析效能，每個字母僅會轉換為星號（＊）處理，不保留原始文字</li>

                    </ul>
                </div>
            </div>
            <div class="col-lg-5 col-md-6">
                <div class="list-wrapper-image mt-4">
                    <picture>
                        <img src="/assets/images/data-security/data-handling.svg" width="433" height="407" alt="Data Handling and Processing" class="img-fluid">
                     </picture>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 34 34" fill="none">
                            <path d="M32.7327 16.5311C33.1681 16.6922 33.1681 17.3078 32.7327 17.4689L21.8072 21.5118C21.6703 21.5624 21.5624 21.6703 21.5118 21.8072L17.4689 32.7327C17.3078 33.1681 16.6922 33.1681 16.5311 32.7327L12.4882 21.8072C12.4376 21.6703 12.3297 21.5624 12.1928 21.5118L1.26725 17.4689C0.831943 17.3078 0.831943 16.6922 1.26725 16.5311L12.1928 12.4882C12.3297 12.4376 12.4376 12.3297 12.4882 12.1928L16.5311 1.26725C16.6922 0.831944 17.3078 0.831943 17.4689 1.26725L21.5118 12.1928C21.5624 12.3297 21.6703 12.4376 21.8072 12.4882L32.7327 16.5311Z" fill="white"/>
                        </svg>
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container container">
        <div class="row no-margin align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="list-wrapper-content-2 pr-40">
                    <h3>進階安全防護措施</h3>
                    <ul class="bullets-box">
                        <li>傳輸與儲存過程皆進行加密保護</li>
                        <li>輕鬆滿足資安與法規遵循需求</li>
                        <li>絕不與第三方共享您的任何資料</li>
                        <li>定期進行安全稽核與威脅防護檢查</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-5 col-md-6">
                <div class="list-wrapper-image mt-4">
                    <picture>
                        <img src="/assets/images/data-security/advanced-security.svg" width="433" height="406" alt="Advanced Security Measures" class="img-fluid">
                     </picture>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 34 34" fill="none">
                            <path d="M32.7327 16.5311C33.1681 16.6922 33.1681 17.3078 32.7327 17.4689L21.8072 21.5118C21.6703 21.5624 21.5624 21.6703 21.5118 21.8072L17.4689 32.7327C17.3078 33.1681 16.6922 33.1681 16.5311 32.7327L12.4882 21.8072C12.4376 21.6703 12.3297 21.5624 12.1928 21.5118L1.26725 17.4689C0.831943 17.3078 0.831943 16.6922 1.26725 16.5311L12.1928 12.4882C12.3297 12.4376 12.4376 12.3297 12.4882 12.1928L16.5311 1.26725C16.6922 0.831944 17.3078 0.831943 17.4689 1.26725L21.5118 12.1928C21.5624 12.3297 21.6703 12.4376 21.8072 12.4882L32.7327 16.5311Z" fill="white"/>
                        </svg>
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd onlyEnterprise pt-0">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <app-compliances-covered></app-compliances-covered>
            </div>
        </div>
    </div>
</section>

<app-hippa-certificate></app-hippa-certificate>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>敏感資料方案主要特色</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>享受全方位功能，專為隱私保護、資料安全與信任建立而設計。以下是我們提供的重點：</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53" fill="none">
                        <path d="M43.0625 39.75C42.1483 39.75 41.4062 40.4903 41.4062 41.4062V48.0312H11.5938V28.1562H16.5625H36.4375H41.4062C42.3205 28.1562 43.0625 27.4159 43.0625 26.5C43.0625 25.5841 42.3205 24.8438 41.4062 24.8438H38.0938V13.25C38.0938 6.85853 32.8931 1.65625 26.5 1.65625C20.1069 1.65625 14.9062 6.85853 14.9062 13.25V24.8438H9.9375C9.02325 24.8438 8.28125 25.5841 8.28125 26.5V49.6875C8.28125 50.6034 9.02325 51.3438 9.9375 51.3438H43.0625C43.9767 51.3438 44.7188 50.6034 44.7188 49.6875V41.4062C44.7188 40.4903 43.9767 39.75 43.0625 39.75ZM18.2188 13.25C18.2188 8.68372 21.9337 4.96875 26.5 4.96875C31.0663 4.96875 34.7812 8.68372 34.7812 13.25V24.8438H18.2188V13.25Z" fill="#7A28A0"/>
                        <path d="M50.8966 25.3671C50.2705 24.6997 49.2221 24.6632 48.5563 25.2893L31.9871 40.7934L24.3204 33.6186C23.6546 32.9942 22.6045 33.0306 21.9801 33.6964C21.3557 34.3639 21.3905 35.4123 22.0579 36.0383L30.8576 44.2716C31.1756 44.5697 31.583 44.7187 31.9888 44.7187C32.3946 44.7187 32.802 44.5697 33.12 44.2716L50.822 27.7091C51.4862 27.0847 51.521 26.0362 50.8966 25.3671Z" fill="#7A28A0"/>
                    </svg>
                    <h3 class="mt-2">完整隱私保障</h3>
                    <p>透過 Trinka 敏感資料方案，你可以放心使用，我們不會保留你傳送至各模組的任何句子、收到的分析結果或你的任何操作紀錄。你的機密資料完全不會儲存在我們的伺服器上，確保隱私安全，讓你高枕無憂。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 56 56" fill="none">
                        <path d="M36.75 36.75H35V33.25C35 31.3935 34.2625 29.613 32.9497 28.3003C31.637 26.9875 29.8565 26.25 28 26.25C26.1435 26.25 24.363 26.9875 23.0503 28.3003C21.7375 29.613 21 31.3935 21 33.25V36.75H19.25C18.7859 36.75 18.3408 36.9344 18.0126 37.2626C17.6844 37.5908 17.5 38.0359 17.5 38.5V50.75C17.5 51.2141 17.6844 51.6593 18.0126 51.9874C18.3408 52.3156 18.7859 52.5 19.25 52.5H36.75C37.2141 52.5 37.6593 52.3156 37.9874 51.9874C38.3156 51.6593 38.5 51.2141 38.5 50.75V38.5C38.5 38.0359 38.3156 37.5908 37.9874 37.2626C37.6593 36.9344 37.2141 36.75 36.75 36.75ZM24.5 33.25C24.5 32.3217 24.8687 31.4315 25.5251 30.7751C26.1815 30.1187 27.0717 29.75 28 29.75C28.9283 29.75 29.8185 30.1187 30.4749 30.7751C31.1313 31.4315 31.5 32.3217 31.5 33.25V36.75H24.5V33.25ZM35 49H21V40.25H35V49Z" fill="#7A28A0"/>
                        <path d="M28 42C27.5359 42 27.0908 42.1844 26.7626 42.5126C26.4344 42.8408 26.25 43.2859 26.25 43.75V45.5C26.25 45.9641 26.4344 46.4092 26.7626 46.7374C27.0908 47.0656 27.5359 47.25 28 47.25C28.4641 47.25 28.9092 47.0656 29.2374 46.7374C29.5656 46.4092 29.75 45.9641 29.75 45.5V43.75C29.75 43.2859 29.5656 42.8408 29.2374 42.5126C28.9092 42.1844 28.4641 42 28 42Z" fill="#7A28A0"/>
                        <path d="M12.25 43.75C9.0011 43.75 5.88526 42.4594 3.58794 40.1621C1.29062 37.8647 0 34.7489 0 31.5C0 28.2511 1.29062 25.1353 3.58794 22.8379C5.88526 20.5406 9.0011 19.25 12.25 19.25C12.7141 19.25 13.1592 19.4344 13.4874 19.7626C13.8156 20.0908 14 20.5359 14 21C14 21.4641 13.8156 21.9092 13.4874 22.2374C13.1592 22.5656 12.7141 22.75 12.25 22.75C9.92936 22.75 7.70376 23.6719 6.06282 25.3128C4.42187 26.9538 3.5 29.1794 3.5 31.5C3.5 33.8206 4.42187 36.0462 6.06282 37.6872C7.70376 39.3281 9.92936 40.25 12.25 40.25C12.7141 40.25 13.1592 40.4344 13.4874 40.7626C13.8156 41.0907 14 41.5359 14 42C14 42.4641 13.8156 42.9093 13.4874 43.2374C13.1592 43.5656 12.7141 43.75 12.25 43.75Z" fill="#7A28A0"/>
                        <path d="M43.75 43.75C43.2859 43.75 42.8408 43.5656 42.5126 43.2374C42.1844 42.9093 42 42.4641 42 42C42 41.5359 42.1844 41.0907 42.5126 40.7626C42.8408 40.4344 43.2859 40.25 43.75 40.25C46.0706 40.25 48.2962 39.3281 49.9372 37.6872C51.5781 36.0462 52.5 33.8206 52.5 31.5C52.5 29.1794 51.5781 26.9538 49.9372 25.3128C48.2962 23.6719 46.0706 22.75 43.75 22.75C43.2859 22.75 42.8408 22.5656 42.5126 22.2374C42.1844 21.9092 42 21.4641 42 21C42 20.5359 42.1844 20.0908 42.5126 19.7626C42.8408 19.4344 43.2859 19.25 43.75 19.25C46.9989 19.25 50.1147 20.5406 52.4121 22.8379C54.7094 25.1353 56 28.2511 56 31.5C56 34.7489 54.7094 37.8647 52.4121 40.1621C50.1147 42.4594 46.9989 43.75 43.75 43.75Z" fill="#7A28A0"/>
                        <path d="M43.75 22.75C43.2859 22.75 42.8408 22.5656 42.5126 22.2374C42.1844 21.9092 42 21.4641 42 21C42 17.287 40.525 13.726 37.8995 11.1005C35.274 8.475 31.713 7 28 7C24.287 7 20.726 8.475 18.1005 11.1005C15.475 13.726 14 17.287 14 21C14 21.4641 13.8156 21.9092 13.4874 22.2374C13.1592 22.5656 12.7141 22.75 12.25 22.75C11.7859 22.75 11.3408 22.5656 11.0126 22.2374C10.6844 21.9092 10.5 21.4641 10.5 21C10.5 16.3587 12.3437 11.9075 15.6256 8.62563C18.9075 5.34374 23.3587 3.5 28 3.5C32.6413 3.5 37.0925 5.34374 40.3744 8.62563C43.6563 11.9075 45.5 16.3587 45.5 21C45.5 21.4641 45.3156 21.9092 44.9874 22.2374C44.6592 22.5656 44.2141 22.75 43.75 22.75Z" fill="#7A28A0"/>
                        <path d="M14 43.75H12.25C11.7859 43.75 11.3408 43.5656 11.0126 43.2374C10.6844 42.9092 10.5 42.4641 10.5 42C10.5 41.5359 10.6844 41.0908 11.0126 40.7626C11.3408 40.4344 11.7859 40.25 12.25 40.25H14C14.4641 40.25 14.9092 40.4344 15.2374 40.7626C15.5656 41.0908 15.75 41.5359 15.75 42C15.75 42.4641 15.5656 42.9092 15.2374 43.2374C14.9092 43.5656 14.4641 43.75 14 43.75Z" fill="#7A28A0"/>
                        <path d="M43.75 43.75H42C41.5359 43.75 41.0908 43.5656 40.7626 43.2374C40.4344 42.9092 40.25 42.4641 40.25 42C40.25 41.5359 40.4344 41.0908 40.7626 40.7626C41.0908 40.4344 41.5359 40.25 42 40.25H43.75C44.2141 40.25 44.6592 40.4344 44.9874 40.7626C45.3156 41.0908 45.5 41.5359 45.5 42C45.5 42.4641 45.3156 42.9092 44.9874 43.2374C44.6592 43.5656 44.2141 43.75 43.75 43.75Z" fill="#7A28A0"/>
                    </svg>
                    <h3 class="mt-2">進階資料安全</h3>
                    <p>我們深知保護機密資訊對企業的重要性，特別是希望將研究成果與競爭對手隔離的機構。Trinka 不儲存用戶資料，大幅降低未經授權存取的風險，讓您完全掌握資料主控權。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="53" viewBox="0 0 47 53" fill="none">
                        <path d="M23.2889 2V29.5313" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M38.9009 5.04251H7.67703" stroke="#7A28A0" stroke-width="3" stroke-linejoin="round"/>
                        <path d="M16.2128 29.553H30.3662" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.3557 18.8222C13.3557 22.2003 10.8276 24.9427 7.70082 24.9565C4.57394 24.9565 2.0253 22.2501 2 18.8719L7.67789 5.04326L13.3557 18.8222Z" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.27693 18.8222H13.0788" stroke="#7A28A0" stroke-width="3"/>
                        <path d="M44.5795 18.8222C44.5795 22.2003 42.0515 24.9427 38.9247 24.9565C35.7978 24.9565 33.2491 22.2501 33.2238 18.8719L38.9017 5.04326L44.5795 18.8222Z" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M33.5008 18.8222H44.3026" stroke="#7A28A0" stroke-width="3"/>
                        <path d="M21.1802 38.7451L40.2999 38.7444" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M34.6233 51H11.955" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.27794 38.7444L16.1724 38.7451" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M36.0825 44.8727L40.2999 44.872" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.27794 44.872L18.3013 44.8727" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M23.3091 44.8726L31.0747 44.8724" stroke="#7A28A0" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <h3 class="mt-2">合規更簡單</h3>
                    <p>全球各地對資料保護有嚴格規範，對企業而言，保護智慧財產更是關鍵。Trinka 採用零資料儲存策略，有效簡化合規程序，降低法規與法律風險，同時確保研究內容的機密性。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-11">
                <div class="trinka-title text-center">
                    <h3 class="text-white">準備好為敏感資訊加上一層最嚴密的防護了嗎？</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button type="button" (click)="scroll(target)" class="white-btn">歡迎與我們聯繫！</button>
                </div>
            </div>
        </div>  
    </div>
</section>

<app-grammar-without-internet
    [windowsButton]="false"
    [sensitiveButton]="true"
    [modalButton]="true"
    (scrollToTarget)="scrollToTarget()"
></app-grammar-without-internet>

<section class="bg-gradient1 section-pd pb-0">
    <div class="intergrationOptions">
        <div class="trinka_container container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>選擇最適合您需求的整合方案</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="trinka_container container">
            <div class="row align-items-center">
                <div class="col-12">
                    <div class="media">
                        <div class="media-left">
                            <img src="/assets/images/cloud-data-sensitive.svg" width="119" height="123" alt="trinka cloud editor" />
                        </div>
                        <div class="media-body">
                            <div class="media-title">
                                <h3>01</h3>
                                <p>使用 Trinka </p>
                                <span>Cloud</span>
                            </div>
                            <p>透過 Trinka 團隊雲端版安全協作，隨時隨地在您偏好的瀏覽器中輕鬆存取與編輯文件，全面提升寫作品質。</p>
                        </div>
                    </div>
                    <div class="media">
                        <div class="media-left">
                            <img src="/assets/images/data-sensitive-js.png"  class="img-fluid" width="394" height="383" alt="trinka js" />
                        </div>
                        <div class="media-body">
                            <div class="media-title">
                                <h3>02</h3>
                                <p>部署 Trinka </p>
                                <span>JS</span>
                            </div>
                            <p>只需在瀏覽器或應用程式中插入一段小巧的 JavaScript（JS）程式碼，即可為整個團隊啟用 Trinka。TrinkaJS 為即時運行，不會將任何資料儲存至我們的伺服器。</p>
                        </div>
                    </div>
                    <div class="media">
                        <div class="media-left">
                            <img src="/assets/images/data-api.png" class="img-fluid" width="393" height="356"  alt="trinka grammar checker api" />
                        </div>
                        <div class="media-body">
                            <div class="media-title">
                                <h3>03</h3>
                                <p>整合 Trinka</p>
                                <span>API</span>
                            </div>
                            <p>透過簡潔易用的 API 架構，將 Trinka 強大的功能嵌入您現有的應用程式中。不論是即時或背景文法檢查，皆可輕鬆實現。</p>
                        </div>
                    </div>
                    <div class="media">
                        <div class="media-left">
                            <img src="/assets/images/on-premise-data-sensitive.svg" width="124" height="108" alt="trinka for premises" />
                        </div>
                        <div class="media-body">
                            <div class="media-title">
                                <h3>04</h3>
                                <p>安裝 Trinka </p>
                                <span>本地部署版</span>
                            </div>
                            <p>將 Trinka 建置於您企業的本地或雲端基礎架構上，確保寫作效能與資料保密。專屬服務人員將協助您無縫整合。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd" #target>
        <div class="trinka_container container" #targetElement>
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>聯繫我們</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>請填寫您的資料，我們將儘快與您聯繫。</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-8">
                    <div class="contact-us-form">
                        <div class="form-wrapper" *ngIf="formSection">
                            <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                                <h6 class="text-center mb-4">Share your requirements with us and our team will respond to you promptly.</h6>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group w-100" >
                                            <mat-form-field appearance="outline">
                                                <mat-label>Nature of business*</mat-label>
                                                <input matInput placeholder="" formControlName="NatureBusinessType">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group w-100" >
                                            <mat-form-field appearance="outline">
                                                <mat-label>Organization name*</mat-label>
                                                <input matInput placeholder="" formControlName="contactFormSubjects">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group w-100" >
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Tell us a bit about your requirement</mat-label>
                                                <textarea matInput placeholder="E.g. approximare number of users, monthly word count volume per user, customizations needed, etc." formControlName="contactFormMessage"></textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group w-100" >
                                            <mat-form-field appearance="outline">
                                                <mat-label>Name*</mat-label>
                                                <input matInput placeholder="" formControlName="contactFormName">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group w-100" >
                                            <mat-form-field appearance="outline">
                                                <mat-label>Designation*</mat-label>
                                                <input matInput placeholder="" formControlName="DesignationTypes">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group w-100" >
                                            <mat-form-field appearance="outline">
                                                <mat-label>Email*</mat-label>
                                                <input matInput placeholder="" formControlName="contactFormEmail">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group w-100" >
                                            <mat-form-field appearance="outline">
                                                <mat-label>Contact Number* (incl. ISD code)</mat-label>
                                                <input type="number" matInput placeholder="" formControlName="contactphoneNo">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <input type="text" formControlName="website" style="display:none">
                                <div class="btn-group justify-content-center">
                                    <button type="submit" class="filled-btn" [disabled]="isSubmitting">Submit</button>
                                </div>
                            </form>
                        </div>  
                        <div class="thank_section contact_us_form" *ngIf="thankSection">
                            <div class="form-group">
                                <svg width="90px" height="90px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>checkmark-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-102.000000, -1141.000000)" fill="#00ab48"> <path d="M124.393,1151.43 C124.393,1151.43 117.335,1163.73 117.213,1163.84 C116.81,1164.22 116.177,1164.2 115.8,1163.8 L111.228,1159.58 C110.85,1159.18 110.871,1158.54 111.274,1158.17 C111.677,1157.79 112.31,1157.81 112.688,1158.21 L116.266,1161.51 L122.661,1150.43 C122.937,1149.96 123.548,1149.79 124.027,1150.07 C124.505,1150.34 124.669,1150.96 124.393,1151.43 L124.393,1151.43 Z M118,1141 C109.164,1141 102,1148.16 102,1157 C102,1165.84 109.164,1173 118,1173 C126.836,1173 134,1165.84 134,1157 C134,1148.16 126.836,1141 118,1141 L118,1141 Z" id="checkmark-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
                                <h2>感謝您！</h2>
                                <p>我們會儘快和您聯絡。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>